import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'site.home',
    // Sitio público de la empresa (secciones desde el CMS).
    component: () => import('./views/RootView.vue'),
    meta: { layout: 'site' },
  },
  {
    path: '/productos/:slug',
    name: 'site.producto',
    component: () => import('./views/ProductoPagina.vue'),
    props: true,
    meta: { layout: 'site' },
  },
  {
    path: '/noticias',
    name: 'site.noticias',
    component: () => import('./views/NoticiasList.vue'),
    meta: { layout: 'site' },
  },
  {
    path: '/noticias/:slug',
    name: 'site.noticia',
    component: () => import('./views/NoticiaDetalle.vue'),
    props: true,
    meta: { layout: 'site' },
  },
]

export default routes
